// Error mapping for Cognito CRUD operations
export const CognitoErrorMap: Record<string, string> = {
  UsernameExistsException: "This email is already registered. Please log in.",
  InvalidParameterException:
    "Invalid input provided. Please check your details.",
  CodeMismatchException: "Incorrect verification code. Please try again.",
  NotAuthorizedException: "Invalid email or password. Please try again.",
  UserNotFoundException: "No account found with this email. Please sign up.",
  LimitExceededException: "Too many attempts. Please try again later.",
  InvalidPasswordException:
    "Password must be at least 8 characters with numbers, letters, and special characters.",
  ExpiredCodeException: "Verification code expired. Please request a new one.",
  TooManyRequestsException: "Too many requests. Please wait and try again.",
  UserNotConfirmedException: "Account not verified. Please verify your email.",
  AliasExistsException: "This email or phone number is already in use.",
  CodeDeliveryFailureException:
    "Failed to send verification code. Please try again.",
  ForbiddenException: "Access denied. Please check your credentials.",
  ResourceNotFoundException: "Requested resource not found.",
  TooManyFailedAttemptsException:
    "Too many failed attempts. Please try again later.",
  UserLambdaValidationException: "Invalid user data. Please check your input.",
  UnexpectedLambdaException: "An unexpected error occurred. Please try again.",
  InvalidLambdaResponseException:
    "Invalid response from server. Please try again.",
  TokenExchangeFailed:
    "Failed to exchange authorization code. Please try again.",
  TokenExchangeError: "Error during token exchange. Please try again.",
  Default: "Something went wrong. Please try again or contact support.",
};
